import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=c0564392&scoped=true&"
import script from "./AppCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=c0564392&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0564392",
  null
  
)

export default component.exports